import { AfterViewInit, Directive, Input } from '@angular/core';

@Directive({
  selector: '[irisAutoFocus]',
  standalone: true,
})
export class IrisAutoFocusDirective implements AfterViewInit {
  @Input('irisAutoFocus') component?: { focus?: () => void };

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.component?.focus?.();
    });
  }
}
